import { Route } from '@angular/router';
import { activeSessionRedirectGuard } from './infrastructure/guards/active-session-redirect.guard';

export const appRoutes: Route[] = [
  {
    path: '',
    loadComponent: () =>
      import('./presentation/root/root.component').then((m) => m.RootComponent),
    children: [
      {
        path: '',
        pathMatch: 'full',
        canActivate: [activeSessionRedirectGuard],
        loadComponent: () =>
          import('../landing/landing-page.component').then(
            (m) => m.LandingPageComponent
          ),
      },
      {
        path: 'support',
        loadComponent: () =>
          import('../landing/support/landing-support-page.component').then(
            (m) => m.LandingSupportPageComponent
          ),
      },
      {
        path: 'reset-password',
        loadComponent: () =>
          import('./domain/auth/reset-password/reset-password-page.component').then(
            (m) => m.ResetPasswordPageComponent
          ),
      },
      {
        path: 'legal/:slug',
        loadComponent: () =>
          import('./domain/legal/legal-page.component').then(
            (m) => m.LegalPageComponent
          ),
      },
      {
        path: 'app',
        loadComponent: () =>
          import('./presentation/app-shell/app-shell.component').then(
            (m) => m.AppShellComponent
          ),
        loadChildren: () =>
          import('./domain/domain.routes').then((m) => m.routes),
      },
    ],
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },
];
